import React, { useState, useEffect } from 'react';

export default function FinancesInvestmentCompare() {
  const [ticker1, setTicker1] = useState('');
  const [amount1, setAmount1] = useState('');
  const [ticker2, setTicker2] = useState('');
  const [amount2, setAmount2] = useState('');
  const [comparisons, setComparisons] = useState([]);
  const [prices, setPrices] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchComparisons();
    fetchPrices();
  }, []);

  const fetchComparisons = async () => {
    setLoading(true);
    const response = await fetch('/api/InvestmentCompare/');
    const data = await response.json();
    setComparisons(data);
    setLoading(false);
  };

  const fetchPrices = async () => {
    const response = await fetch('/api/finances/getprices');
    const data = await response.json();
    setPrices(data);
  };

  const handleUpdatePricesClick = async () => {
    await fetch('/api/finances/updateassetprices');
    fetchPrices();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await fetch('/api/InvestmentCompare/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ticker1,
        amount1: parseFloat(amount1),
        ticker2,
        amount2: parseFloat(amount2)
      })
    });
    setTicker1('');
    setAmount1('');
    setTicker2('');
    setAmount2('');
    fetchComparisons();
    fetchPrices();
  };

  const handleDelete = async (id) => {
    await fetch(`/api/InvestmentCompare/${id}`, {
      method: 'DELETE',
    });
    fetchComparisons();
    fetchPrices();
  };

  const formatCurrency = (value) => {
    return value != null ? value.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : '-';
  };

  const buttonStyle = {
    padding: "2px",
    fontSize: "20px",
    marginLeft: "10px",
    border: 'none',
    backgroundColor: 'white',
  };

  const inputStyle = {
    marginRight: "10px",
    marginBottom: "10px"
  }

  return (
    <div>
      <h2>
        Compare Investments
        <button style={buttonStyle} onClick={handleUpdatePricesClick} title="Update Prices">&#10227;</button>
      </h2>
      <form onSubmit={handleSubmit} style={{marginBottom: '2em', marginTop: '2em'}}>
        <div>
          <input style={inputStyle} placeholder="Symbol 1" value={ticker1} onChange={e => setTicker1(e.target.value)} required />
          <input style={inputStyle} placeholder="Quantity 1" type="number" value={amount1} onChange={e => setAmount1(e.target.value)} required />
        </div>
        <div>
          <input style={inputStyle} placeholder="Symbol 2" value={ticker2} onChange={e => setTicker2(e.target.value)} required />
          <input style={inputStyle} placeholder="Quantity 2" type="number" value={amount2} onChange={e => setAmount2(e.target.value)} required />
          <button type="submit">Add Comparison</button>
        </div>
      </form>
      <h3>All Comparisons</h3>
      {loading ? <div>Loading...</div> : (
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Date Added</th>
              <th>Symbol</th>
              <th>Quantity</th>
              <th>Current Price</th>
              <th>Total</th>
              <th></th>
              <th>Symbol</th>
              <th>Quantity</th>
              <th>Current Price</th>
              <th>Total</th>
              <th></th>
              <th>Difference</th>
              <th>Match Price</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {comparisons.map(c => (
              <tr key={c.id}>
                <td>{new Date(c.dateAdded).toLocaleDateString()}</td>
                <td>{c.ticker1}</td>
                <td>{c.amount1}</td>
                <td>{formatCurrency(prices[c.ticker1]?.price)}</td>
                <td>{formatCurrency(prices[c.ticker1]?.price ? prices[c.ticker1].price * c.amount1 : null)}</td>
                <td>vs</td>
                <td>{c.ticker2}</td>
                <td>{c.amount2}</td>
                <td>{formatCurrency(prices[c.ticker2]?.price)}</td>
                <td>{formatCurrency(prices[c.ticker2]?.price ? prices[c.ticker2].price * c.amount2 : null)}</td>
                <td></td>
                <td>
                  {prices[c.ticker1]?.price && prices[c.ticker2]?.price
                    ? formatCurrency((prices[c.ticker2].price * c.amount2) - (prices[c.ticker1].price * c.amount1))
                    : '-'}
                </td>
                <td>
                  {c.amount2 && prices[c.ticker1]?.price
                    ? ((prices[c.ticker1].price * c.amount1) / c.amount2).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                    : '-'}
                </td>
                <td><button onClick={() => handleDelete(c.id)}>Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
